import { useState, useEffect } from 'react';
import { IconDeviceFloppy } from '@tabler/icons-react';
import { showToast } from '../components/ui/Toast';
import { useSiteContent } from '../context/SiteContentContext';
import { getContactMessages } from '../lib/dataStore';

const FIELDS = ['contact_email', 'contact_instagram', 'contact_whatsapp', 'contact_hours', 'contact_categories'];

export default function AdminContact() {
  const { content, updateBulk } = useSiteContent();
  const [form, setForm] = useState({ ...content });
  const [saved, setSaved] = useState(true);
  const messages = getContactMessages();

  // The saved text can arrive after this screen opens; show it unless
  // Andre has already started editing.
  useEffect(() => {
    if (saved) setForm({ ...content });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content]);

  function set(key, value) { setForm(prev => ({ ...prev, [key]: value })); setSaved(false); }
  const [saving, setSaving] = useState(false);
  async function save() {
    if (saving) return;
    setSaving(true);
    // Only this screen's fields, so nothing else is ever overwritten.
    const updates = {};
    FIELDS.forEach(k => { updates[k] = form[k] || ''; });
    const r = await updateBulk(updates);
    setSaving(false);
    if (r && r.error) { showToast(r.error, 'error'); return; }
    setSaved(true);
    showToast('Contact page saved');
  }

  function field(key, label) {
    return (
      <div className="adm-field">
        <label className="adm-label">{label}</label>
        <input className="adm-input" value={form[key] || ''} onChange={e => set(key, e.target.value)} />
      </div>
    );
  }

  return (
    <div>
      <h1 className="adm-title">Contact page</h1>
      <p className="adm-sub">Edit contact details, form categories, and view incoming messages.</p>

      <div className="adm-card">
        <div className="adm-card-title">Contact details</div>
        {field('contact_email', 'Email')}
        {field('contact_instagram', 'Instagram handle')}
        {field('contact_whatsapp', 'WhatsApp number')}
        {field('contact_hours', 'Workshop hours')}
      </div>

      <div className="adm-card">
        <div className="adm-card-title">Form categories</div>
        <div className="adm-field">
          <label className="adm-label">Categories (comma-separated)</label>
          <input className="adm-input" value={form['contact_categories'] || ''} onChange={e => set('contact_categories', e.target.value)} />
        </div>
      </div>

      <div className="adm-save-bar">
        <span className={`adm-save-status ${saved ? 'adm-save-status--saved' : ''}`}>
          {saved ? '✓ Saved' : '● Unsaved'}
        </span>
        <button className="adm-btn" onClick={save}><IconDeviceFloppy size={14} /> Save</button>
      </div>

      <h2 className="adm-title" style={{ marginTop: 28 }}>Messages ({messages.length})</h2>
      {messages.length === 0 ? (
        <p style={{ fontSize: 12, color: '#888' }}>No messages yet. Messages from the contact form will appear here.</p>
      ) : (
        messages.map((msg, i) => (
          <div className="adm-card" key={i}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#888', marginBottom: 8 }}>
              <span>{msg.name} &lt;{msg.email}&gt;</span>
              <span>{msg.category}</span>
            </div>
            <p style={{ fontSize: 13, color: '#333', lineHeight: 1.6 }}>{msg.message}</p>
          </div>
        ))
      )}
    </div>
  );
}
